import React, { useMemo, useState, useEffect } from "react"
import he from "he";
import "./ValuesSection.css";
import { fixImagePaths } from "../util";
import { useSelector } from "react-redux";


const OverlappingSection = () => {
  const [whatWeDoContent, setWhatWeDoContent] = useState("");
  const { page } = useSelector((state) => state.data);

    useEffect(() => {
      if (page?.statusCode === 200 && page?.data?.what_we_do_section) {
        setWhatWeDoContent(he.decode(page.data.what_we_do_section.htmlContent));
      }
    }, [page]);

  const processedContent = useMemo(() => fixImagePaths(whatWeDoContent), [whatWeDoContent]);
  
    return (
      <div>
        {processedContent && (
          <div className="whatWeDo" dangerouslySetInnerHTML={{ __html: processedContent }} />
        )}
      </div>
    );
  };


export default OverlappingSection;